import {useContext} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import MapPoligonJS from "components/maps/MapPoligonJS";
import AuthContext from "context/AuthContext";
import {useTranslation} from "react-i18next";
import MapPoligonManager from "components/maps/MapPoligonManager";

const PrevZones = (props) => {
    const {panel} = useContext(AuthContext);
    const {t: tF} = useTranslation("forms");

    const getCenter = (points) => {
        let latSum = 0;
        let lngSum = 0;

        points.forEach((p) => {
            latSum += p.lat;
            lngSum += p.lng;
        });

        return [latSum / points.length, lngSum / points.length];
    };

    return (
        <div className={`col preview-row ${props.showPreview ? "" : "d-none"}`} style={{width: "300px", maxWidth: "300px"}}>
            <div className="row">
                <div className="col-12 p-0">
                    <div className="preview-card" style={{width: "300px"}}>
                        <div className="preview-header">
                            <div className="preview-icon">
                                <FontAwesomeIcon icon="layer-group" />
                            </div>
                            <div className="preview-title">
                                <label>{tF("common.name")}</label>
                                <div>{props.zone.name}</div>
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{tF("common.description")}</label>
                            <div className="preview-input">{props.zone.description}</div>
                        </div>
                        <div className="preview-item">
                            <label>{tF("common.panel")}</label>
                            <div className="preview-input">{props.zone.panel}</div>
                        </div>
                        <div className="preview-item">
                            <MapPoligonManager
                                id="prev-zone-map"
                                center={getCenter(props.zone.polylines)}
                                zone={props.zone}
                                height="200px"
                                zoom={13}></MapPoligonManager>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrevZones;
